module.exports = __webpack_public_path__ + "static/media/email-tickets.7a701618.png";